const ibmBeaconAwardFinalist2021 = [
  {
    type: "paragraph",
    text: "Comsense Technologies is proud to be honored as a <a href='https://www.ibm.com/partnerworld/events/beacon-award-winners' style='color: #E31837;text-decoration:none'>2021 IBM Beacon Award </a>finalist for Outstanding AI & Data Solution. Now in their 22nd year, the IBM Beacon Awards celebrate the next generation of innovators, creators and thinkers that use IBM technology, like hybrid cloud and AI, to power innovative solutions for partners and their clients.",
  },
  {
    type: "paragraph",
    text: "Comsense’s AI-driven Customer OS platform is powered by IBM Cloud Pak for Data, an open platform that helps customers automate and simplify how they collect, organize, and analyze data.  Customer OS empowers customers to add actionable intelligence to their data, such as using predictive models to recommend sales strategies and marketing performance dashboards to guide near real-time decision-making.",
  },
  {
    type: "paragraph",
    text: "By eliminating close to 90% of IT dependency and allowing marketing functions to fully understand their customers and “market to one,” Comsense helps deliver a superior customer experience that provides an edge to companies.",
  },
  {
    type: "paragraph",
    text: "Comsense Technologies was selected as a Beacon Award finalist by a panel of judges including industry specialists, IBM executives and analysts who recognized how AI-driven Customer OS enables client success with IBM technology.",
  },
  {
    type: "paragraph",
    text: "For more information on the 2021 IBM Beacon Awards, including a detailed list of winners and finalists, please visit here.",
  },
  {
    type: "paragraph",
    text: "To learn more about Comsense Technologies, visit <a href='https://www.comsensetechnologies.com/' style='color: #E31837;text-decoration:none'>www.comsensetechnologies.com</a>",
  },
];

export default ibmBeaconAwardFinalist2021;
